// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventPage_EventPage__S5_O6 .EventPage_Button__sSzJ2 {
  margin: 30px 0 0;
}
.EventPage_EventPage__S5_O6 .EventPage_BackButton__Rvf4E {
  margin: 0 0 10px;
}
.EventPage_EventPage__S5_O6 .EventPage_Errors__Nd706 {
  margin: 10px 0 0;
}
.EventPage_EventPage__S5_O6 .EventPage_Errors__Nd706 .EventPage_ErrorsItem__lJkbz {
  color: #ff0000;
}`, "",{"version":3,"sources":["webpack://./src/components/EventPage/EventPage.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAMI;EACI,gBAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,gBAAA;AAPR;AASQ;EACI,cCjBA;ADUZ","sourcesContent":["@use '../../variables.scss' as *;\n\n.EventPage {\n    .Title {\n    }\n\n    .Button {\n        margin: 30px 0 0;\n    }\n\n    .BackButton {\n        margin: 0 0 10px;\n    }\n\n    .Errors {\n        margin: 10px 0 0;\n\n        .ErrorsItem {\n            color: $color-red;\n        }\n    }\n}\n","$box-shadow-default: 0 2px 10px rgba(0, 0, 0, 0.5);\n$color-red: #ff0000;\n$color-white: #ffffff;\n$color-blue: #228be6;\n$color-peach: #fff3df;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EventPage": `EventPage_EventPage__S5_O6`,
	"Button": `EventPage_Button__sSzJ2`,
	"BackButton": `EventPage_BackButton__Rvf4E`,
	"Errors": `EventPage_Errors__Nd706`,
	"ErrorsItem": `EventPage_ErrorsItem__lJkbz`
};
export default ___CSS_LOADER_EXPORT___;
